var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { defineMessages, injectIntl } from 'react-intl';
import { getLineHeaders as getLineHeadersAction, getSportLineHeaders as getSportLineHeadersAction, getLeagueLineHeaders as getLeagueLineHeadersAction, fetchPreMatchMenu as fetchPreMatchMenuAction, clearLine as clearLineAction } from '../../../actions/creators/lines';
import { fetchFastsportGamesToken } from "../../../actions/games/creators";
import { setActiveTab as setActiveTabAction } from '../../../actions/creators/sidebar';
import { openAuthModal } from "../../../actions/auth/creators/Login";
import { sportSortFunc } from '../../../rendering-commons/Sorting';
import * as TimeFilter from '../../../constants/TimeFilter';
import PopularLines from './PopularLines';
import Sport from './Sport';
var messages = defineMessages({
    sports_filter_all: {
        id: "sports.filter.all",
        defaultMessage: "За все время"
    },
    sports_filter_next_1: {
        id: "sports.filter.next_1",
        defaultMessage: "Ближайший час"
    },
    sports_filter_next_12: {
        id: "sports.filter.next_12",
        defaultMessage: "12 часов"
    },
    sports_filter_next_24: {
        id: "sports.filter.next_24",
        defaultMessage: "24 часа"
    }
});
var Sports = /** @class */ (function (_super) {
    __extends(Sports, _super);
    function Sports() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            languageId: 5,
            filterType: TimeFilter.ALL,
            expandedLeague: _this.props.leagueId,
            allSport: true,
            loading: false
        };
        _this.filterClick = function (type, e) {
            e.preventDefault();
            localStorage.setItem('filterType', type);
            _this.setState({
                filterType: type
            });
        };
        _this.onFastsportClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var gamblerId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        gamblerId = this.props.auth.user.gamblerId;
                        if (!gamblerId) return [3 /*break*/, 2];
                        this.setState({ loading: true });
                        return [4 /*yield*/, this.props.fetchFastsportGamesToken(gamblerId)];
                    case 1:
                        _a.sent();
                        this.setState({ loading: false });
                        return [2 /*return*/];
                    case 2:
                        this.props.openAuthModal();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Sports.prototype.componentDidMount = function () {
        if (localStorage.getItem('backward') && this.props.sports.size > 0 && this.props.sports.first().get('id') === +this.props.match.params.sportId) {
            this.setState({
                allSport: false,
                filterType: localStorage.getItem('filterType') ? +localStorage.getItem('filterType') : TimeFilter.ALL
            });
            localStorage.removeItem('backward');
        }
        else {
            this.loadData(this.props, this.state);
            localStorage.removeItem('backward');
            localStorage.removeItem('filterType');
            this.setState({
                filterType: TimeFilter.ALL
            });
        }
        this.props.setActiveTabAction('sport');
    };
    Sports.prototype.componentWillReceiveProps = function (nextProps, nextState) {
        if ((nextProps.sportId !== this.props.sportId || this.props.location !== nextProps.location) && !localStorage.getItem('backward')) {
            this.loadData(nextProps, nextState.filterType);
            this.setState({
                filterType: TimeFilter.ALL
            });
        }
        if (nextProps.languageId !== this.props.languageId && !localStorage.getItem('backward')) {
            this.loadData(nextProps, nextState.filterType);
            this.setState({
                filterType: TimeFilter.ALL
            });
        }
    };
    Sports.prototype.loadData = function (props, filterType) {
        var sportId = props.sportId, leagueId = props.leagueId, languageId = props.languageId;
        if (sportId) {
            if (!leagueId) {
                this.props.getSportLineHeadersAction({ sportId: sportId, languageId: languageId, filterType: filterType });
                this.setState({
                    expandedLeague: false
                });
            }
            else if (leagueId) {
                this.props.getLeagueLineHeadersAction({ leagueId: leagueId, languageId: languageId, filterType: filterType });
                this.setState({
                    expandedLeague: true
                });
            }
            this.setState({
                allSport: false
            });
        }
        else {
            // this.props.getLineHeadersAction({ languageId: languageId });
            this.setState({
                allSport: true,
                expandedLeague: false
            });
        }
    };
    Sports.prototype.render = function () {
        var _a = this.state, filterType = _a.filterType, allSport = _a.allSport, expandedLeague = _a.expandedLeague;
        var _b = this.props, sports = _b.sports, leagues = _b.leagues, fetching = _b.fetching, gridLocalization = _b.gridLocalization, intl = _b.intl, sportId = _b.sportId;
        var renderSports = [];
        var props = {
            gridLocalization: gridLocalization,
        };
        var filteredSprots = sports;
        if (sportId) {
            filteredSprots = filteredSprots.filter(function (s) {
                if (s.get('id') === Number(sportId)) {
                    return true;
                }
                return false;
            });
        }
        if (!allSport) {
            filteredSprots.sort(sportSortFunc).map(function (s, i) {
                renderSports.push(_jsx(Sport, __assign({ sport: s, leagues: leagues }, props, { filterType: filterType, section: 'preMatch', expandedLeague: expandedLeague }), i));
            });
        }
        else {
            sports.sort(sportSortFunc).map(function (s, i) {
                renderSports.push(_jsx(PopularLines, { sport: s, section: 'menu' }, i));
            });
        }
        var blcCls = allSport ? 'blc blc_league' : 'blc_line_all';
        if (fetching) {
            return (_jsx("div", __assign({ className: 'content' }, { children: _jsx("div", { className: 'please_wait' }) })));
        }
        return (_jsx(React.Fragment, { children: _jsxs("div", __assign({ className: 'content' }, { children: [_jsx("div", __assign({ className: 'blc_sports new_header' }, { children: !allSport && _jsx("div", __assign({ className: 'slider topmenu' }, { children: _jsxs("ul", { children: [_jsx("li", __assign({ className: filterType === TimeFilter.ALL ? 'active' : '', onClick: this.filterClick.bind(this, TimeFilter.ALL) }, { children: intl.formatMessage(messages.sports_filter_all) })), _jsx("li", __assign({ className: filterType === TimeFilter.HR1 ? 'active' : '', onClick: this.filterClick.bind(this, TimeFilter.HR1) }, { children: intl.formatMessage(messages.sports_filter_next_1) })), _jsx("li", __assign({ className: filterType === TimeFilter.HR12 ? 'active' : '', onClick: this.filterClick.bind(this, TimeFilter.HR12) }, { children: intl.formatMessage(messages.sports_filter_next_12) })), _jsx("li", __assign({ className: filterType === TimeFilter.HR24 ? 'active' : '', onClick: this.filterClick.bind(this, TimeFilter.HR24) }, { children: intl.formatMessage(messages.sports_filter_next_24) }))] }) })) })), _jsx("div", __assign({ className: blcCls }, { children: renderSports }))] })) }));
    };
    Sports.propTypes = {
        gridLocalization: PropTypes.object.isRequired,
        languageId: PropTypes.number.isRequired,
        fetching: PropTypes.bool.isRequired,
        sports: PropTypes.object.isRequired,
        leagues: PropTypes.object.isRequired,
        getLineHeadersAction: PropTypes.func.isRequired,
        getSportLineHeadersAction: PropTypes.func.isRequired,
        getLeagueLineHeadersAction: PropTypes.func.isRequired,
        clearLineAction: PropTypes.func.isRequired,
        fetchPreMatchMenuAction: PropTypes.func.isRequired,
        setActiveTabAction: PropTypes.func.isRequired,
        sportId: PropTypes.string
    };
    return Sports;
}(React.Component));
var mapStateToProps = function (state, props) { return ({
    fetching: state.application.getIn(['menu', 'fetching']),
    sports: state.application.getIn(['menu', 'sports']),
    leagues: state.application.getIn(['menu', 'leagues']),
    languageId: state.application.get('languageId'),
    sportId: props.match.params.sportId,
    leagueId: props.match.params.leagueId,
    auth: state.auth
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    getLineHeadersAction: getLineHeadersAction,
    getSportLineHeadersAction: getSportLineHeadersAction,
    getLeagueLineHeadersAction: getLeagueLineHeadersAction,
    setActiveTabAction: setActiveTabAction,
    fetchPreMatchMenuAction: fetchPreMatchMenuAction,
    clearLineAction: clearLineAction,
    openAuthModal: openAuthModal,
    fetchFastsportGamesToken: fetchFastsportGamesToken
}, dispatch); };
Sports = connect(mapStateToProps, mapDispatchToProps)(Sports);
export default injectIntl(Sports);



// WEBPACK FOOTER //
// ./src/components/grid/sports/index.js